import { render, staticRenderFns } from "./OrgPage.vue?vue&type=template&id=2c494b75&"
import script from "./OrgPage.vue?vue&type=script&lang=js&"
export * from "./OrgPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports